import * as React from "react";

import { StatusBadge as BaseStatusBadge } from "@/components/ui/status-badge";
import { TASK_STATUS_CONFIG, toCanonicalTaskStatus, type TaskStatusValue } from "@/types/status";

interface StatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status?: TaskStatusValue | string | null;
}

export function StatusBadge({ status, className, ...props }: StatusBadgeProps) {
  const statusKey = typeof status === "string" ? toCanonicalTaskStatus(status as TaskStatusValue) : "todo";
  const statusConfig = TASK_STATUS_CONFIG[statusKey] ?? TASK_STATUS_CONFIG.todo;

  return (
    <BaseStatusBadge
      variant={statusConfig.variant}
      icon={statusConfig.icon}
      label={statusConfig.label}
      className={className}
      {...props}
    />
  );
}
